import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router";
import { authRoutes, publicRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import Login from "../auth/login/login";
import { PrivateRoute } from "../../core/common/context/PrivateRouteContext";
import { all_routes } from "./all_routes";
import Loading from "../../core/common/custom-loading/Loading";

const InvoicePaymentPage = lazy(
  () =>
    import(
      "../Nestfin Superadmin/organization/tenant-invoices/InvoicePaymentPage"
    ),
);

const Error500 = lazy(() => import("../pages/error/error-500"));

const ALLRoutes: React.FC = () => {
  return (
    // Pages in router.link are lazy, so one boundary here covers every route
    // while its chunk is in flight.
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path={all_routes.login} element={<Login />} />
        <Route path={all_routes.error500} element={<Error500 />} />
        <Route
          path={all_routes.invoicePayment}
          element={<InvoicePaymentPage />}
        />
        <Route
          path={all_routes.invoicePaymentAlias}
          element={<InvoicePaymentPage />}
        />
        <>
          <Route
            element={
              <PrivateRoute>
                <Feature />
              </PrivateRoute>
            }
          >
            {publicRoutes.map((route, idx) => (
              <Route path={route.path} element={route.element} key={idx} />
            ))}
          </Route>

          <Route
            element={
              <PrivateRoute>
                <AuthFeature />
              </PrivateRoute>
            }
          >
            {authRoutes.map((route, idx) => (
              <Route path={route.path} element={route.element} key={idx} />
            ))}
          </Route>
        </>
      </Routes>
    </Suspense>
  );
};

export default ALLRoutes;
